module.exports = __webpack_public_path__ + "img/37.b48190c2.jpg";